// extracted by mini-css-extract-plugin
module.exports = {"container":"Paginate_container__bClSu"};